const RequiredFieldAsterisk = ({
    shouldRenderAsterisk = true,
}: {
    shouldRenderAsterisk?: boolean;
}): JSX.Element => {
    if (shouldRenderAsterisk) {
        return <span className='asterisk'>*</span>;
    }
    return <></>;
};

export default RequiredFieldAsterisk;
